import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import OPTooltip from "components/material/tooltip"
import Logo from "components/logo"

/**
 * The top-left Omega Point mark, shared by every header shell so the tooltip and the `.logo`
 * chrome (see styles/_top-bar-logo) can't drift apart again. Shells that must intercept the
 * navigation — an unsaved-changes prompt, say — pass `onClick` instead of navigating directly.
 */
export default function LogoHomeLink({ account, onClick }) {
  return <OPTooltip title="Go to resources page">
    {onClick
      ? <div className="logo" onClick={onClick}><Logo /></div>
      : <Link className="logo" to={`/${account}/home`}><Logo /></Link>}
  </OPTooltip>
}

LogoHomeLink.propTypes = {
  account: PropTypes.string.isRequired,
  onClick: PropTypes.func,
}
